module.exports = __webpack_public_path__ + "img/unlock.c1cf4a29.svg";